/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as React from "react";
export function AbBooleanRenderer(props) {
  return /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-boolean-renderer", props), booleanToString(props.value));
}
export function booleanToString(value) {
  if (value === true) {
    return AbReactResources.booleanChoices_affirmative();
  } else if (value === false) {
    return AbReactResources.booleanChoices_negative();
  } else {
    return AbReactResources.booleanChoices_unspecified();
  }
}
//# sourceMappingURL=AbBooleanRenderer.js.map
